import React from 'react';
import './tooltip-style.less';

interface TableTooltipCellProps {
  textToShow: any;
  optionalRenderer?: any;
  newClassFromComponent?: string;
}

interface TableTooltipCellState {
  activeTooltip: boolean;
}

class TableTooltipCell extends React.Component<TableTooltipCellProps, TableTooltipCellState> {
  private shortTextRef = React.createRef<HTMLDivElement>();
  constructor(props) {
    super(props);
    this.state = {
      activeTooltip: false
    };
  }

  componentDidMount() {
    const cellText = this.shortTextRef.current;
    if (cellText && this.isEllipsisActive(cellText)) {
      this.setState({ activeTooltip: true });
    }
  }

  private isEllipsisActive(element) {
    return element.offsetWidth < element.scrollWidth;
  }

  render() {
    const activeTooltip = this.shortTextRef.current ? this.isEllipsisActive(this.shortTextRef.current) : false;

    return (
      <span className="table__tooltip">
        <div
          className={this.props.newClassFromComponent ? `table__short-text ${this.props.newClassFromComponent}` : 'table__short-text'}
          ref={this.shortTextRef}
        >
          {this.props.optionalRenderer ? this.props.optionalRenderer : this.props.textToShow}
        </div>

        {activeTooltip ? (
          <div className="table__tooltip-top">
            {this.props.textToShow}
            <i></i>
          </div>
        ) : null}
      </span>
    );
  }
}

export default TableTooltipCell;
